import './product-about.component.pug'
import './product-about.component.scss'
import { Swiper } from 'swiper'
const productAbouts = document.querySelectorAll('.product-about')
if (productAbouts.length > 0) {
  productAbouts.forEach((root) => {
    const swiperInstances = []
    let maxLength = 0
    root.querySelectorAll('.swiper-container').forEach((swiperElement) => {
      maxLength = Math.max(
        maxLength,
        swiperElement.querySelectorAll('.swiper-slide').length
      )
      swiperInstances.push(
        new Swiper(swiperElement, {
          direction: 'horizontal',
          slidesPerView: 1,
          spaceBetween: 10,
          autoHeight: true,
          speed: 800,
          simulateTouch: false,
          breakpoints: {
            1025: {
              direction: 'vertical',
              spaceBetween: 40
            }
          }
        })
      )
    })
    if (window.innerWidth > 1024) {
      import(
        /* webpackChunkName: "interactiveFabric" */ '../../application/interactiveFabric'
      ).then(({ ScrollMagic }) => {
        const controller = new ScrollMagic.Controller()
        const scene = new ScrollMagic.Scene({
          offset:
            window.innerHeight / 2 -
            parseInt(
              document.documentElement.style.getPropertyValue('--header-height')
            ),
          duration: (root.getBoundingClientRect().height * maxLength) / 1.5,
          triggerElement: root
        })
          .addTo(controller)
          .setPin(root)
        const refOffset = maxLength / 1.0
        scene.on('progress', ({ progress }) => {
          const targetSlide = Math.round((progress / refOffset) * maxLength)
          swiperInstances.forEach((swiperInstance) =>
            swiperInstance.slideTo(targetSlide)
          )
        })
      })
    }
  })
}
